import React from 'react'

export default function SolutionTasks() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 1H29C29 1 31 1 31 3V29C31 29 31 31 29 31H3C3 31 1 31 1 29V3C1 3 1 1 3 1Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16.0002 5.58203L9.75016 13.9153L5.5835 9.7487" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.125 10.79H25.375" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16.0002 18.082L9.75016 26.4154L5.5835 22.2487" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.125 23.2905H25.375" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
